<template>
  <div class="image-box">
    <div class="image-item" v-for="(item, index) in imageList" :key="index">
      <div class="del-box" @click="delImg(index)"><van-icon size="18px" name="clear" /></div>
      <van-image lazy-load width="100%" :src="item" @click="previewImg(index)">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
        <template v-slot:error>加载失败</template>
      </van-image>
    </div>
    <van-uploader :after-read="afterRead" :multiple="isIOS()" :preview-image="false" :max-count="3">
      <div class="upload-wrp">
        <div class="upload-box">
          <div class="upload-top">
            <van-loading color="#1989fa" v-if="uploading" />
            <van-image :src="uploadIcon" v-else :width="transPxToRem(122)" :height="transPxToRem(82)" />
          </div>
          <div class="upload-bottom">点击上传店铺资质</div>
        </div>
      </div>
    </van-uploader>
    <div class="bottom-btn-wrp">
      <van-button @click="updateImageList" :loading="saveLoading" type="primary" block>修改</van-button>
    </div>
  </div>
</template>
<script setup>
import { transPxToRem } from '@/utils'
import { ImagePreview, Image as VanImage } from 'vant'
import { Toast } from '@vant/compat'
import { ref, onMounted, computed } from 'vue'
import { uploadApi } from '@/api/upload'
import { getMemberStoreInfoApi, updateStoreInfoApi } from '@/api/user'
import { uploadStyleEnum } from '@/enum/uploadEnum'
import { useUserStore } from '@/store/user'
import { isIOS } from '@/utils/is'
import uploadIcon from '@/assets/img/upload-icon.png'

const userStore = useUserStore()
const userInfo = computed(() => userStore.getUserInfo) //用户信息
const imageList = ref([])
const getImageList = async () => {
  try {
    const resData = await getMemberStoreInfoApi({ puid: userInfo.value.puid })
    imageList.value = resData.certPics
  } catch {}
}
const saveLoading = ref(false)
const updateImageList = async () => {
  try {
    saveLoading.value = true
    await updateStoreInfoApi({ storePuid: userInfo.value.puid, certPics: imageList.value })
    Toast.success('修改成功')
  } finally {
    saveLoading.value = false
  }
}
const previewImg = i => {
  ImagePreview({
    images: imageList.value,
    startPosition: i
  })
}
const delImg = index => {
  imageList.value.splice(index, 1)
}
const uploading = ref(false)
const afterRead = async file => {
  let files = file.length ? file : [file]
  for (let i = 0; i < files.length; i++) {
    const item = files[i]
    uploading.value = true
    const resData = await uploadApi({ file: item.file, style: uploadStyleEnum.STYLE_PIC_STD })
    uploading.value = false
    if (resData) {
      imageList.value.push(resData.file_url.url)
    } else {
      Toast('上传失败')
    }
  }
}

onMounted(() => getImageList())
</script>
<style lang="less" scoped>
.image-box {
  background-color: #fff;
  height: 100vh;
  overflow: auto;
  padding-bottom: 70px;

  .image-item {
    position: relative;
    margin: 16px;

    .del-box {
      color: #d8d8d8;
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 1;
      background-color: #fff;
      border-radius: 50%;
      height: 14px;
    }
  }

  .upload-wrp {
    padding: 16px;
    box-sizing: border-box;
    width: 100vw;
  }

  .upload-box {
    // display: flex;
    // justify-content: center;
    background: #f7f8fa;
    border-radius: 8px;
    overflow: hidden;

    .upload-top {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 136px;
    }

    .upload-bottom {
      text-align: center;
      padding: 10px 0;
      background: #989da7;
      opacity: 0.4;
      color: #ffffff;
    }
  }

  .bottom-btn-wrp {
    position: fixed;
    width: 100%;
    padding: 10px 16px;
    bottom: 0;
    left: 0;
    background-color: var(--van-white);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  }
}
</style>
